import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import InventoryList from '../components/Inventory/InventoryList';
import ViewInventory from '../components/Inventory/ViewInventory';
import EditInventory from '../components/Inventory/EditInventory';

const Inventory = () => {
  return (
    <Routes>
      <Route path="/" element={<InventoryList />} />
      <Route path="/view/:id" element={<ViewInventory />} />
      <Route path="/edit/:id" element={<EditInventory />} />
      <Route path="/edit" element={<EditInventory />} />
    </Routes>
  )
}

export default Inventory;